/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { DataClass } from '../models/DataClass';

/**
* Details about the resource\'s data classes.
*/
export class DataClassesDetails {
  /**
  * List of data classes.
  */
  'dataClasses'?: Array<DataClass>;
  'eonDataClassifications'?: Array<DataClass>;
  /**
  * Whether the data classes are manually overridden. If `true`, the list of data classes is user-defined and remains static. If `false`, the data classes are automatically detected and listed by Eon. 
  */
  'isOverridden'?: boolean;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "dataClasses",
      "baseName": "dataClasses",
      "type": "Array<DataClass>",
      "format": ""
    },
    {
      "name": "eonDataClassifications",
      "baseName": "eonDataClassifications",
      "type": "Array<DataClass>",
      "format": ""
    },
    {
      "name": "isOverridden",
      "baseName": "isOverridden",
      "type": "boolean",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return DataClassesDetails.attributeTypeMap;
  }

  public constructor() {
  }
}

